module.exports = __webpack_public_path__ + "img/30a2d9b3a5c937e0fa3a16bc45d3a5c2.png";